import { IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import CloseRounded from "@mui/icons-material/CloseRounded";
import { routes } from "app/routes";
import { push } from "connected-react-router";
import { useDispatch } from "react-redux";
import { LandingTwoColumnLayout } from "features/landingPage/FunnelMVP/LandingTwoColumnLayout";
import { localImageSrc } from "app/images";
import { useLogEventOnLoad } from "hooks/useLogEventOnLoad";
import { analyticsTrack } from "app/analytics/track";

const useStyles = makeStyles((theme) => ({
    container: {
        background: theme.palette.coral100,
        minHeight: "100vh",
    },

    closeButton: {
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: theme.zIndex.appBar,
    },

    closeIcon: {
        fontSize: 60,

        [theme.breakpoints.down("md")]: {
            fontSize: 40,
        },
    },
}));

export const CancellationFlow = (props: {
    content: React.ReactNode;
    onNext?: () => void;
    continueButtonText?: React.ReactNode;
    pageId: string;
}) => {
    const dispatch = useDispatch();

    const classes = useStyles();
    useLogEventOnLoad(`cancellationFlow.${props.pageId}.viewed`);

    return (
        <div className={classes.container}>
            <IconButton
                data-testid="closeButton"
                className={classes.closeButton}
                onClick={() => {
                    dispatch(push(routes.memberMembership()));
                    analyticsTrack(`cancellationFlow.${props.pageId}.closeModal`);
                }}
            >
                <CloseRounded className={classes.closeIcon} />
            </IconButton>
            <LandingTwoColumnLayout
                content={<>{props.content}</>}
                onNext={() => {
                    if (props.onNext) {
                        props.onNext();
                    }
                    analyticsTrack(`cancellationFlow.${props.pageId}.nextButton.click`);
                }}
                continueButtonText={props.continueButtonText}
                videoUrl="https://storage.googleapis.com/cloud-sangha-images/funnel-experiment-videos/Waves.mp4"
                videoId="cancellationflow"
                thumbnailUrl={localImageSrc("landing/waves-poster.jpg")}
            />
        </div>
    );
};
